import axios from "axios";
import React, { useEffect, useState } from "react";
import Loading from "../../../Shared/Loading";
import ClinicalFindingTableRow from "./ClinicalFindingTableRow";

const ClinicalFindingTable = ({ patientId, refetch, setRefetch }) => {
  const [clinicalFindings, setClinicalFindings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        `https://servercareseebd.careseebd.com/api/v1/findings/get/specific?fieldName=${"userId"}&&fieldValue=${patientId}`
      )
      .then((response) => {
        setClinicalFindings(response?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching clinical findings:", error);
        setLoading(false);
      });
  }, [patientId, refetch]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="mt-8 space-y-4">
      {clinicalFindings?.length === 0 ? (
        <div className="text-center py-8 bg-slate-50 border border-dashed border-slate-200 rounded-2xl">
          <p className="text-sm font-semibold text-slate-400">
            No clinical records logged for this patient.
          </p>
        </div>
      ) : (
        <>
          <div>
            <h4 className="text-sm font-bold text-slate-500 uppercase tracking-wider">Previous Clinical Records</h4>
          </div>

          <div className="w-full overflow-x-auto border border-slate-100 rounded-xl shadow-sm">
            <table className="w-full text-left border-collapse" cellspacing="0">
              <thead>
                <tr className="bg-slate-50/75 border-b border-slate-100">
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Eye</th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                    SPH <span className="text-slate-400 block font-medium">(-25 to +25)</span>
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                    CYL <span className="text-slate-400 block font-medium">(-25 to +25)</span>
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                    Axis <span className="text-slate-400 block font-medium">(0° to 180°)</span>
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                    Add <span className="text-slate-400 block font-medium">(+0.75 - +5)</span>
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Distance</th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">LOG MAR</th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Near</th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">LOG MAR</th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Clinical Diagnosis</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {[...clinicalFindings]?.reverse()?.map((patientRecord) => (
                  <ClinicalFindingTableRow
                    key={patientRecord?._id}
                    patient={patientRecord}
                    refetch={refetch}
                    setRefetch={setRefetch}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default ClinicalFindingTable;
